import React from 'react';
import './Label.scss';

interface LabelProps extends React.LabelHTMLAttributes<HTMLLabelElement> {
  children: React.ReactNode;
}

export const Label: React.FC<LabelProps> = ({ children, className = '', ...props }) => {
  return (
    <label className={`ui-label ${className}`} {...props}>
      {children}
    </label>
  );
};
